import { MapTo } from "@adobe/aem-react-editable-components";
import { PackCodes } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const packCodesEditConfig = {
    emptyLabel: "PackCodes",
    isEmpty: (props) => {
        if (!props.title)
            return true;
        if (props.restrictedContent &&
            (!props.restrictedTitle || !props.restrictedDescription || !props.restrictedCta || !props.restrictedCtaUrl))
            return true;
        return false;
    },
    getProps: (props) => ({
        title: props.title,
        background: props.background,
        mobileHeaderImage: props.mobileHeaderImage,
        mobileBottomImage: props.mobileBottomImage,
        loggedInDescription: props.loggedInDescription,
        loggedOutDescription: props.loggedOutDescription,
        limitText: props.limitText,
        limitTextReached: props.limitTextReached,
        inputPlaceholder: props.inputPlaceholder,
        buttonTitle: props.buttonTitle,
        confirmationTitle: props.confirmationTitle,
        errorCodeMessage: props.errorCodeMessage,
        errorEarningMessage: props.errorEarningMessage,
        bottomMessageHistory: props.bottomMessageHistory,
        bottomMessageHistoryLink: props.bottomMessageHistoryLink,
        packCodeName: props.packCodeName,
        packCodeText: props.packCodeText,
        packCodeLink: props.packCodeLink,
        earningMessage: props.earningMessage,
        headerLogo: props.headerLogo,
        componentTitle: props.componentTitle,
        closeButtonText: props.closeButtonText,
        restrictedContent: props.restrictedContent,
        restrictedTitle: props.restrictedTitle,
        restrictedDescription: props.restrictedDescription,
        restrictedCta: props.restrictedCta,
        restrictedCtaUrl: props.restrictedCtaUrl,
        signInTitle: props.signInTitle,
        signInUrl: props.signInUrl,
        registerUrl: props.registerUrl,
        registerTitle: props.registerTitle,
    }),
};
export default MapTo("loyalty/components/pack-codes")(withAemAuthoring(PackCodes, packCodesEditConfig));
